module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre01",
      "id": "pre01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmta"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro",
      "id": "intro"
    }
  }, [_vm._v("Introduction: Civilization in Disarray")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch-1",
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("1")])]), _vm._v("   The Quintessential Victims of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch-2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("2")])]), _vm._v("   Saving the Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch-3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("3")])]), _vm._v("   A “Psychological Marshall Plan”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch-4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("4")])]), _vm._v("   Renationalizing Displaced Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch-5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("5")])]), _vm._v("   Children as Spoils of War in France")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch-6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("6")])]), _vm._v("   Ethnic Cleansing and the Family in Czechoslovakia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch-7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("7")])]), _vm._v("   Repatriation and the Cold War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch-8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("8")])]), _vm._v("   From Divided Families to a Divided Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmta1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/archival#arc",
      "id": "arc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Archival Sources and Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "id": "note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmta"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0